import { cloneElement } from 'react';
import type { FunctionComponent, ReactElement } from 'react';

import { RouterProps } from '../../../types';
import AccessGate from '../../generic/Gates/AccessGate';

const ProjectHistoryPage: FunctionComponent<RouterProps> = (props) => (
  <div>
    <div className="container margin-top">
      <AccessGate level="free">{cloneElement(props.children as ReactElement, props)}</AccessGate>
    </div>
  </div>
);

export default ProjectHistoryPage;
